/* ============================================================
   URBANLUX — CRO v3 ADDITION
   Barra de envío gratis + Cross-sell en carrito
   Se añade a urbanlux-cro.js sin tocar las funciones existentes
   ============================================================ */
(function () {
  'use strict';

  const FREE_SHIPPING_THRESHOLD = 30; // €30 — coincide con el trust bar existente
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* IDs de productos para cross-sell, por precio ascendente (ajusta si cambian handles) */
  const CROSSSELL_HANDLES = [
    'soporte-magn-u00e9tico-para-m-u00f3vil-rotaci-u00f3n-360-u00b0-iman-n52',
    'baliza-v16-homologada-dgt-obligatoria-2026',
    'difusor-de-aromas-para-coche-ultras-u00f3nico-led-7-colores',
    'organizador-de-maletero-plegable-impermeable-3-compartimentos'
  ];

  /* ============================================================
     1. BARRA DE ENVÍO GRATIS — Carrito (drawer y página)
     ============================================================ */
  function getCartTotal() {
    return fetch('/cart.js').then(r => r.json());
  }

  function renderShippingBar(cart) {
    const total = cart.total_price / 100; // céntimos a euros
    const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - total);
    const pct = Math.min(100, Math.round((total / FREE_SHIPPING_THRESHOLD) * 100));
    const complete = remaining <= 0;

    let bar = $('.ul-shipping-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'ul-shipping-bar';
      const container = $('.drawer__inner .cart-drawer__form, #CartDrawer-CartItems, .cart__contents');
      if (container) container.insertAdjacentElement('beforebegin', bar);
      else return;
    }

    const barText = complete
      ? '<strong>¡Envío gratis desbloqueado!</strong>'
      : 'Añade <strong>' + remaining.toFixed(2) + '€</strong> más para envío gratis';

    bar.classList.toggle('is-complete', complete);
    bar.innerHTML = `
      <div class="ul-shipping-bar-text">${barText}</div>
      <div class="ul-shipping-bar-track">
        <div class="ul-shipping-bar-fill" style="width:${pct}%"></div>
      </div>`;
  }

  function initShippingBar() {
    if (!$('.cart-drawer, .cart__contents, #main-cart-items')) return;
    getCartTotal().then(renderShippingBar).catch(() => {});
  }

  /* ============================================================
     2. CROSS-SELL EN CARRITO — Productos relacionados
     ============================================================ */
  function fetchProduct(handle) {
    return fetch(`/products/${handle}.js`).then(r => r.ok ? r.json() : null).catch(() => null);
  }

  function renderCrossSell(cart) {
    if ($('.ul-cart-crosssell') || cart.item_count === 0) return;

    const cartHandles = new Set(cart.items.map(i => i.handle));
    const candidates = CROSSSELL_HANDLES.filter(h => !cartHandles.has(h)).slice(0, 2);
    if (candidates.length === 0) return;

    Promise.all(candidates.map(fetchProduct)).then(products => {
      const valid = products.filter(Boolean);
      if (valid.length === 0) return;

      const wrap = document.createElement('div');
      wrap.className = 'ul-cart-crosssell';
      wrap.innerHTML = `
        <div class="ul-cart-crosssell-title">También te puede interesar</div>
        <div class="ul-cart-crosssell-items">
          ${valid.map(p => `
            <div class="ul-cart-crosssell-item" data-variant-id="${p.variants[0].id}">
              <img class="ul-cart-crosssell-img" src="${p.featured_image ? p.featured_image.replace('.jpg','_100x.jpg').replace('.png','_100x.png') : ''}" alt="${p.title}" loading="lazy">
              <div class="ul-cart-crosssell-info">
                <div class="ul-cart-crosssell-name">${p.title}</div>
                <div class="ul-cart-crosssell-price">${(p.price / 100).toFixed(2)}€</div>
              </div>
              <button class="ul-cart-crosssell-add" type="button">+ Añadir</button>
            </div>`).join('')}
        </div>`;

      const footer = $('.drawer__footer, .cart__footer, .cart-drawer__footer');
      const target = footer || $('.cart-drawer, .cart__contents');
      if (target) target.insertAdjacentElement('beforebegin', wrap);

      wrap.querySelectorAll('.ul-cart-crosssell-add').forEach(btn => {
        btn.addEventListener('click', () => {
          const id = btn.closest('.ul-cart-crosssell-item').dataset.variantId;
          btn.textContent = 'Añadiendo...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, quantity: 1 })
          })
            .then(r => r.json())
            .then(() => {
              btn.textContent = '✓ Añadido';
              btn.classList.add('is-added');
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              setTimeout(() => location.reload(), 700);
            })
            .catch(() => { btn.textContent = '+ Añadir'; });
        });
      });
    });
  }

  /* ============================================================
     INIT — se ejecuta tras cargar el carrito y en cada apertura
     ============================================================ */
  function refreshCartExtras() {
    getCartTotal().then(cart => {
      renderShippingBar(cart);
      // Reset cross-sell para recalcular tras cambios en el carrito
      const existing = $('.ul-cart-crosssell');
      if (existing) existing.remove();
      renderCrossSell(cart);
    }).catch(() => {});
  }

  function boot() {
    initShippingBar();
    getCartTotal().then(renderCrossSell).catch(() => {});

    // Reaccionar a apertura del drawer (evento estándar de Shopify Dawn/Studio)
    document.addEventListener('cart:refresh', refreshCartExtras);
    document.body.addEventListener('click', (e) => {
      if (e.target.closest('[data-action="add-to-cart"], .product-form__submit, cart-remove-button a, .quantity__button')) {
        setTimeout(refreshCartExtras, 600);
      }
    });

    // Observador simple: si el drawer se abre, refrescar
    const drawer = $('cart-drawer, #CartDrawer');
    if (drawer) {
      const mo = new MutationObserver(() => {
        if (drawer.classList.contains('active') || drawer.hasAttribute('open')) {
          refreshCartExtras();
        }
      });
      mo.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
